var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBedaTecnology(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_343_131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0982 5.9549C18.08 5.93371 18.0618 5.91445 18.0416 5.89519C17.791 5.62938 17.5242 5.37898 17.2432 5.14207C17.2008 5.1074 17.1583 5.07273 17.1179 5.03613C16.7319 4.82618 16.2852 4.70869 15.8082 4.70869C14.3429 4.70869 13.1545 5.84126 13.1545 7.23963C13.1545 7.85022 13.3809 8.41265 13.7608 8.84795C13.8962 9.00397 14.0519 9.14458 14.2196 9.26593C14.3166 9.33912 14.4096 9.41231 14.4985 9.49128C14.6441 9.56833 14.7997 9.62997 14.9594 9.67812C16.5035 10.9205 17.4837 12.7811 17.4837 14.8575C17.4837 18.6 14.3005 21.6317 10.3754 21.6317C6.45042 21.6317 3.26715 18.5981 3.26715 14.8575C3.26715 12.7676 4.25952 10.8993 5.81983 9.65886C5.98556 9.60685 6.14321 9.53944 6.29278 9.45854C6.31097 9.4412 6.33118 9.4258 6.35139 9.40846C6.49489 9.29289 6.64647 9.17925 6.80614 9.07524C6.87486 9.0136 6.93954 8.94811 7.00219 8.87685C7.02038 8.85759 7.03655 8.83832 7.05272 8.81521C7.41652 8.38183 7.63278 7.83095 7.63278 7.23385C7.63278 5.82777 6.43628 4.6875 4.95883 4.6875C4.49802 4.6875 4.06347 4.79922 3.68552 4.99568C3.68552 4.99568 3.68552 4.99568 3.6835 4.99568C3.31364 5.29616 2.96398 5.61975 2.64262 5.96645C1.02572 7.70961 0.043457 9.99786 0.043457 12.5038C0.043457 17.9432 4.66981 22.354 10.3795 22.354C16.0892 22.354 20.7155 17.9451 20.7155 12.5038C20.7155 9.98823 19.7272 7.6942 18.0982 5.95297V5.9549Z",
    fill: "url(#paint0_radial_343_131)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.82422 9.65921C6.18802 9.36643 6.58618 9.11026 7.0086 8.89453C6.69937 9.24509 6.28908 9.51282 5.82422 9.65921Z",
    fill: "url(#paint1_radial_343_131)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.65967 8.28596C9.07602 8.1858 9.50652 8.12223 9.94712 8.09912C9.50046 8.12609 9.06996 8.19735 8.65967 8.30522V8.28596Z",
    fill: "url(#paint2_radial_343_131)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8108 9.76916C15.5279 9.76916 15.257 9.72871 15.0044 9.64974C16.5627 10.9037 17.551 12.7797 17.551 14.8754C17.551 18.6506 14.3394 21.7093 10.38 21.7093C6.42066 21.7093 3.20909 18.6506 3.20909 14.8754C3.20909 12.7951 4.18328 10.9345 5.72135 9.68056C5.48084 9.7499 5.2282 9.78457 4.96343 9.78457C3.49003 9.78457 2.2915 8.6443 2.2915 7.23629C2.2915 6.77402 2.42086 6.34257 2.64722 5.9689C2.89178 5.56055 3.25356 5.22348 3.6881 4.99812H3.69012C4.06807 4.80166 4.50261 4.68994 4.96343 4.68994C6.44087 4.68994 7.63738 5.83021 7.63738 7.23629C7.63738 7.83532 7.42112 8.3862 7.05732 8.81765C7.04115 8.83884 7.02296 8.8581 7.00679 8.87929C6.94616 8.94863 6.87946 9.01604 6.81074 9.07768C6.65107 9.18169 6.49949 9.29533 6.35599 9.4109C6.33578 9.42824 6.31758 9.44365 6.29737 9.46098C5.27468 10.322 4.64611 11.5008 4.64611 12.8048C4.64611 15.4359 7.21496 17.5681 10.3821 17.5681C13.5492 17.5681 16.118 15.4378 16.118 12.8048C16.118 11.5181 15.5036 10.3509 14.5052 9.49373C14.4162 9.41475 14.3212 9.33963 14.2262 9.26837C14.0565 9.14895 13.9029 9.00641 13.7675 8.8504C13.3875 8.41316 13.1611 7.85266 13.1611 7.24207C13.1611 5.8437 14.3495 4.71113 15.8149 4.71113C16.2918 4.71113 16.7385 4.83055 17.1245 5.03857C17.5308 5.25623 17.8683 5.57404 18.1028 5.95541C18.3352 6.33101 18.4706 6.77017 18.4706 7.24015C18.4706 8.63659 17.2822 9.76916 15.8149 9.76916H15.8108Z",
    fill: "url(#paint3_radial_343_131)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.83841 9.11426C6.70097 9.24138 6.55141 9.35117 6.3877 9.44555C6.52917 9.32999 6.68076 9.21827 6.83841 9.11426Z",
    fill: "url(#paint4_radial_343_131)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0996 1.84471V9.02535C12.0996 9.93063 11.3296 10.6645 10.3796 10.6645C9.42972 10.6645 8.65967 9.93063 8.65967 9.02535V1.84471C8.65967 0.939424 9.42972 0.205566 10.3796 0.205566C10.8546 0.205566 11.2851 0.388549 11.5964 0.687101C11.9076 0.983726 12.0996 1.39207 12.0996 1.84663V1.84471Z",
    fill: "url(#paint5_radial_343_131)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0996 1.33428V6.27482C12.0996 6.89696 11.3296 7.40161 10.3796 7.40161C9.42972 7.40161 8.65967 6.89696 8.65967 6.27482V1.33428C8.65967 0.710214 9.42972 0.205566 10.3796 0.205566C10.8546 0.205566 11.2851 0.332691 11.5964 0.536862C11.9076 0.741032 12.0996 1.02225 12.0996 1.33428Z",
    fill: "url(#paint6_radial_343_131)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_343_131",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(15.0141 13.2675 -42.3721 6.60437 2.7618 7.10404)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000817"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504808,
    stopColor: "#010A20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081939"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_343_131",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0.860214 0.574269 -2.42766 0.285863 5.97996 8.99913)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000817"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504808,
    stopColor: "#010A20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081939"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_343_131",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0.935079 0.154778 -2.63893 0.0770462 8.82897 8.12731)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000817"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504808,
    stopColor: "#010A20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081939"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_343_131",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(11.7509 12.7815 -33.1628 6.36243 4.41903 7.01795)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000817"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504808,
    stopColor: "#010A20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081939"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_343_131",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0.327351 0.248802 -0.923835 0.12385 6.44696 9.15957)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000817"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504808,
    stopColor: "#010A20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081939"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_343_131",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(2.49844 7.85461 -7.05097 3.90991 9.11202 1.6362)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000817"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504808,
    stopColor: "#010A20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081939"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_343_131",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(2.49844 5.4042 -7.05097 2.69014 9.11202 1.18989)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000817"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504808,
    stopColor: "#010A20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081939"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_343_131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.6721,
    height: 22.1486,
    fill: "white",
    transform: "translate(0.043457 0.205566)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedaTecnology);
export default __webpack_public_path__ + "static/media/Beda-Tecnology.f168817b1492def7d2a74b34c78046f8.svg";
export { ForwardRef as ReactComponent };